export default class AbstractBandsCalculator {
    constructor(salary, bands) {
        this.salary = salary;
        this.bands = bands;
    }

    calculate() {
        throw new Error('Method requires implementation.');
    }

    getDeductableIncome() {
        throw new Error('Method requires implementation.');
    }

    calculateBand(band) {
        let deductable = 0;
        const income = this.getDeductableIncome();

        const bandRate = this.bands.getRate(band);
        const bandMin = this.bands.getMin(band);
        const bandMax = this.bands.getMax(band);

        if (!bandRate) {
            return deductable;
        }

        if (income > bandMin) {
            let incomeWithinBand;
            if (bandMax && income > bandMax) {
                incomeWithinBand = bandMax - bandMin;
            } else {
                incomeWithinBand = income - bandMin;
            }

            deductable = incomeWithinBand * bandRate;
        }

        return deductable;
    }
}